import React from 'react';
import { MessageSquareIcon, UserIcon, CheckIcon, XIcon, ClockIcon } from 'lucide-react';
const MessagingHub = () => {
  // Load pending requests from localStorage
  const pendingRequests = JSON.parse(localStorage.getItem('pendingRequests') || '[]');
  return <div className="max-w-3xl mx-auto py-6" data-id="element-1785">
      <h1 className="text-xl font-bold mb-6" data-id="element-1786">Messages</h1>
      {pendingRequests.length > 0 ? <div className="space-y-4" data-id="element-1787">
          {pendingRequests.map((request: any) => <div key={request.mentorId} className="bg-white rounded-xl shadow-sm p-4" data-id="element-1788">
              <div className="flex items-center justify-between" data-id="element-1789">
                <div className="flex items-center" data-id="element-1790">
                  <img src={request.mentorImage} alt={request.mentorName} className="w-12 h-12 rounded-full object-cover" data-id="element-1791" />
                  <div className="ml-3" data-id="element-1792">
                    <h3 className="font-semibold" data-id="element-1793">{request.mentorName}</h3>
                    <div className="flex items-center text-sm text-gray-500" data-id="element-1794">
                      <ClockIcon size={14} className="mr-1" data-id="element-1795" />
                      Request pending
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-1796">
                  <span className="text-sm text-purple-600 bg-purple-50 px-3 py-1 rounded-full" data-id="element-1797">
                    Pending Response
                  </span>
                </div>
              </div>
            </div>)}
        </div> : <div className="text-center py-12" data-id="element-1798">
          <MessageSquareIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-1799" />
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1800">
            No messages yet
          </h3>
          <p className="text-gray-500 mb-4" data-id="element-1801">
            Start by requesting mentorship from someone who inspires you
          </p>
        </div>}
    </div>;
};
export default MessagingHub;